/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ImageCaptionIcon = /*#__PURE__*/ createSvgIcon(
  'ImageCaptionIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M19.54.87H.45v14.48h19.09V.87z" />
            <path d="M15.59 6.88a2.05 2.05 0 100-4.1 2.05 2.05 0 000 4.1zM13.37 8.95l-2.04 2.7-3.37-4.46-4.48 5.94H16.52l-3.15-4.18zM0 17.46c1.43 0 1.43 1.67 2.86 1.67s1.42-1.67 2.85-1.67c1.43 0 1.43 1.67 2.85 1.67 1.42 0 1.43-1.67 2.86-1.67s1.43 1.67 2.86 1.67 1.43-1.67 2.86-1.67 1.43 1.67 2.86 1.67" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default ImageCaptionIcon;
